module.exports = __webpack_public_path__ + "img/Group 27918@2x.206ca0c4.png";